import isObject from 'lodash/isObject';

// --------------------------------------------------------------------------

const populateNext = (data) => {
  const { _id, name, nameEs, icon, conveyorTemplate, next } = data;

  return [
    {
      _id,
      conveyorTemplateId: conveyorTemplate,
      name,
      nameEs,
      icon,
    },
    ...(isObject(next) ? populateNext(next) : []),
  ];
};

export const templatesToStepsArray = (list) =>
  list?.reduce((acc, { firstStep }) => [...acc, ...(firstStep ? populateNext(firstStep) : {})], []);
